// import { gsap } from 'gsap';
import { random as _random } from 'underscore';

export default class{

    constructor(options) {

    	// https://openweathermap.org

        this.defaults = {
        	main 		: undefined,
			retry 		: 2, // times to retry if some error occurs
            time_retry  : 2*1000, // 2 seconds
            
            // mspc app key!
			// appid		: 'd308ad0a59fd3921c86d533939a06203',
			// lat 		: '40.742037',
			// lon 		: '-73.987563',
			// url 		: 'https://api.openweathermap.org/data/2.5/onecall',
			// units 		: 'imperial',

			// meaning: when you are ready just set the appid and simulate to false
			simulate 	:  false,

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'weather-api';
		this.main			= this.options.main;
		this.index_retry	= 0;


		this.index_icon 	= -1;
		this.temp 			= false;

		this.init( 277 );
    }

    init( delay ){
    	
        const production = document.location.hostname.indexOf( 'madisonsquarepark.org' ) !== -1;

        //console.log( 'production = ' + production );
    	if ( this.options.simulate  || !production ){
    		this.fakeCall();
    	}
    	else{
    		setTimeout(()=>this.callWeatherApi(), delay );
    	}
    	
    }


    callWeatherApi(){
    	let url = this.options.url;

    	// https://api.openweathermap.org/data/2.5/onecall?lat={lat}&lon={lon}&exclude={part}&appid={API key}

    	// url += '?lat=' 		+ this.options.lat;
    	// url += '&lon=' 		+ this.options.lon;
    	// url += '&appid=' 	+ this.options.appid;
    	// url += '&units='	+ this.options.units;

		$.ajax( {
			type: 			'get',
		 	url: 			$('BODY').data('ajax-url'),
            data:           { action : 'weatherapi' },
		 	dataType: 		'json'
		}).then(
	      	(response) => this.response(response),
	      	(data, status) => this.error(data,status)
		);	    	
    }

    response( response ){

      	// console.log('weatherApi: ', response );

      	let current 	= response.current,

      		temp 		= current.temp,
      		weather 	= current.weather,
      		state 		= weather[0].main;

      	this.index_icon 	= this.getWeatherConditionFromState( state );
      	this.temp 			= temp;
      	this.update();
    }

    getWeatherConditionFromState( state ){

    	// https://openweathermap.org/weather-conditions#Weather-Condition-Codes-2

    	switch ( state ){
    		case 'Thunderstorm':
    			// 2
    			return 2;
    		break;
    		case 'Drizzle':
    			// in between 0
    			return 0;
    		break;
    		case 'Rain':
    			// 5
    			return 5;
    		break;
    		case 'Snow':
    			// 4
    			return 4;
    		break;
    		case 'Clear':

                if ( this.isNight() ){

                    // moon
                    return 6;
                }

    			// 3
    			return 3;
    		break;
    		case 'Clouds':
    			// 1
    			return 1;
    		break;
    		default:
    			// Atmosphere --> Drizzle 0
    			return 0;
    	}

    }

    isNight(){
        // we don't want to show for clear the Sunny icon at night, swicth to the Moon!
        //let today = this.getNYDate();

        let today = this.convertTZ( new Date(), 'America/New_York' );

        const hours = today.getHours();

        //console.log( hours );

        //from 8 pm to 6 am
        if ( (hours >= 20 && hours <= 23) || (hours >=0 && hours < 6 ) ){
            return true;
        }
        return false;
    }

    convertTZ(date, tzString) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
    }

    /*
    getNYDate(){

        // Get time zone offset for NY, USA
        const getEstOffset = () => {
            const stdTimezoneOffset = () => {
                var jan = new Date(0, 1)
                var jul = new Date(6, 1)
                return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
            }

            var today = new Date()
            
            const isDstObserved = (today) => {
                return today.getTimezoneOffset() < stdTimezoneOffset()
            }

            if (isDstObserved(today)) {
                return -4
            } else {
                return -5
            }
        }

        const d = new Date();

        // convert to msec since Jan 1 1970
        const localTime = d.getTime();

        // obtain local UTC offset and convert to msec
        const localOffset = d.getTimezoneOffset() * 60 * 1000;

        // obtain UTC time in msec
        const utcTime = localTime + localOffset;

        // obtain and add destination's UTC time offset
        const estOffset = getEstOffset();
        const usa = utcTime + (60 * 60 * 1000 * estOffset);

        // convert msec value to date string
        const nd = new Date(usa)

        return nd;
    }
    */

    update(){
    	let $w, $temp, $icon, j;

    	$( '.widget-weather' ).each( (i, el) => {

    		$w = $(el);

    		for( j=0; j<$w.find( '.icon-w span' ).length; j++ ){
    			$icon = $w.find( '.icon-w span' ).eq( j );
    			if ( j === this.index_icon ){
    				$icon.addClass( 'active' );
    			}
    			else{
    				$icon.removeClass( 'active' );
    			}
    		}

    		if ( this.temp ){
    			$temp = $w.find( '.temp' );
    			if ( $temp.length > 0 ){
    				$temp.text( Math.round( parseFloat(this.temp) ) + '°F')
    			}
    		}

    	});

    }

    setManually( index, temp ){
        this.index_icon     = parseInt(index);
        this.temp           = temp;
        this.update();
    }


    fakeCall(){
      	this.index_icon 	= _random( 0, 5 );
      	this.temp 			= _random( 30, 60 );
      	this.update();
      	setTimeout(()=>this.fakeCall(), _random( 7, 12 )*1000 );
    }

    error( data, status ){
      	console.log('weatherApi: Request failed.  Returned status of: ', status );
      	
      	this.index_retry++;
      	if ( this.index_retry < this.options.retry ){
      		this.init( this.options.time_retry );
      		return;
      	}

        this.setManually( $('#drawer-lawns').attr('data-icon'), $('#drawer-lawns').attr('data-temp') );

    }

    destroy(){

    }

}



